import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { LoadingSkeleton } from '../../components/LoadingSkeleton';
import commonStyles from '../shared/styles.module.css';
import styles from './UserInfo.module.css';
function UserInfoLoading() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={classNames(styles.trigger, styles.login, commonStyles.navigationLink)}><LoadingSkeleton className={styles.image} width="40px" height="40px" borderRadius="100%" /><LoadingSkeleton className={styles.label} height="28px" width="164px" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export default UserInfoLoading;